import { Alert, Button, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMyProfileQuery } from "../../../../../../services/profileService/profile-api";
import { VariancePostCommand } from "../../../../../../services/varianceService/commands/VariancePostCommand";
import { useAppSelector } from "../../../../../../app/hooks";
import { useVarianceSaveMutation } from "../../../../../../services/varianceService/variance-api";
import { PermissionChecker } from "../../../../../../services/varianceService/util/PermissionChecker";

type ownProps={
    setNotify:Function;
    setMessage:Function;}

function VarianceDetailsSave(props:ownProps){
    const variance = useAppSelector(
        (state) => state.varianceRequest.varianceRequest
      );
      const [varianceSave, status] = useVarianceSaveMutation();
      const myProfile = useMyProfileQuery();
      const canEdit = (): boolean => {
      return PermissionChecker.canEditVariance(myProfile.data, variance);
    }
    const [notify, setNotify] = useState(false);
    useEffect(() => {
      setNotify(status.isSuccess);
    }, [status.isSuccess]);
    const handleSave = async () => {
      try {
        let command = new VariancePostCommand(variance);
        await varianceSave(command).unwrap();
        props.setNotify(true);
        props.setMessage("Incident Saved Successfully!");
      } catch (error) {
        console.error('Failed to save incident:', error);
      }
    };
  return <React.Fragment>
   {canEdit()  && (
              <Button
                variant="outlined"
                color="primary"
                onClick={() => handleSave()}
              >
                Save
              </Button>
            )}
             <Snackbar
        open={notify}
        onClose={() => setNotify(false)}
        color="success"
        autoHideDuration={6000}
        message="Incident Saved Successfully!"
      />
      <Snackbar open={status.isError}>
        <Alert color="error">
          {"An error has occured: " + JSON.stringify(status.error)}
        </Alert>
      </Snackbar>
 </React.Fragment>
}

export {VarianceDetailsSave}